import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";

export default function UtmTemplateEdit() { 
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let utmTemplateId = decode.id;
    let disabled = decode.disabled;

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [agency, setAgency] = React.useState('');
    let [utm, setUtm] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    const navigate = useNavigate();

    let refName = React.useRef(); 

    React.useEffect(() => {
        (async function() {
            try {
                const resAgency = await Utils.getAgency();
                setAgency(resAgency);
                const resUtm = await Utils.getUtm();
                setUtm(resUtm);
                const resView = await getView();
                setData(resView);
                setStatusChecked(resView.status===1);
                refName.current.value = resView.name;
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/utmTemplate/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: utmTemplateId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = () => {
        let name = refName.current.value;
        let items = [];
        let checkboxes = document.getElementsByName('agencyIds[]');
        for (let i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].checked) {
                items.push({'agencyId': checkboxes[i].value});
            }
        }

        let utmSourceItem =[];
        let utmCheckboxes = document.getElementsByName('utmSourceIds[]');
        for (let i = 0; i < utmCheckboxes.length; i++) {
            if(utmCheckboxes[i].checked) {
                utmSourceItem.push({'utmSourceId': utmCheckboxes[i].value});
            }
        }

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ UTM");
            refName.current.focus();
        }
        else if(items.length <= 0) {
            toast.error("กรุณาระบุ Agency อย่างน้อย 1 รายการ");
        }
        else if(utmSourceItem.length <= 0) {
            toast.error("กรุณาระบุ UTM อย่างน้อย 1 รายการ");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                name: name,
                                currentName: data.name,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                items: items,
                                utmSourceItem: utmSourceItem
                            };
                            fetch(Config.url.API_URL +'/api/utmTemplate/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/utmTemplate', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onCheckHeadDefault = (utmData) => {
        let tempData = [...utmData];
        tempData.map((row) => {
            row.headChecked = false;
            for(let rs of row.items) {
                if(rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_CHECKED || rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED || rs.checkVal===1) {
                    row.headChecked = true;
                    break;
                }
            }
            return row;
        });
        return tempData;
    };

    if(data) {
        let it = [];
        if(data.items) {
            for(let item of data.items) {
                it.push(parseInt(item.agencyId));
            }
        }
        for(let ow of agency) {
            ow.isChecked = it.includes(ow.id);
        }

        let st = [];
        if(data.sourceItems) {
            for(let item of data.sourceItems) {
                st.push(parseInt(item.utmSourceId));
            }
        }
        for(let ow of utm) {
            if(ow.items) {
                for(let s of ow.items) {
                    s.isChecked = st.includes(s.id);
                    s.checkVal = s.isChecked ? 1:0;
                }
            }
        }
        onCheckHeadDefault(utm);
    }

    const onCheckAll = (isChecked, parentId) => {
        utm.map((row, index) => {
            if(parentId === row.id) {
                row.items.map((rs, index2) => {
                    let chkSourceId = 'utmSourceCheck' + rs.id;
                    if(document.getElementById(chkSourceId)) {
                        document.getElementById(chkSourceId).checked = isChecked;
                    }
                });
            }
        });
    };

    const onCheckHead = (parentId) => {
        utm.map((row, index) => {
            if(parentId === row.id) {
                for(let rs of row.items) {
                    let chkSourceId = 'utmSourceCheck' + rs.id;
                    let checked = document.getElementById(chkSourceId).checked;
                    if(checked) {
                        document.getElementById('utmCheck' + row.id).checked = true;
                        break;
                    }
                    else {
                        document.getElementById('utmCheck' + row.id).checked = false;
                    }
                }
            }
        });
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Template</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Template <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} disabled={disabled} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="agencyx" className="form-label">Agency</label>
                                {
                                    agency.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                        agency.map((row, index) => {
                                            let chkId = 'agencyCheck' + row.id;
                                            return (
                                                <div key={index} className="form-check ms-2">
                                                    <input className="form-check-input" name="agencyIds[]" type="checkbox" value={row.id} id={chkId} defaultChecked={row.isChecked} disabled={disabled} />
                                                    <label className="form-check-label" htmlFor={chkId}>
                                                        {row.name} {row.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                                    </label>
                                                </div>);
                                        })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="utm" className="form-label">UTM</label>
                                {
                                    utm.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                        utm.map((row, index) => {
                                            let chkId = 'utmCheck' + row.id;
                                            return (
                                                <div key={index} className="form-check ms-2 mb-2">
                                                    <input className="form-check-input" name="utmIds[]" type="checkbox" value={row.id} id={chkId} onChange={e => {onCheckAll(e.target.checked, row.id)}} defaultChecked={row.headChecked} disabled={disabled} />
                                                    <label className="form-check-label fw-bold mb-1" htmlFor={chkId}>
                                                        {row.utmPrefix === 1 ? 'utm_':''}{row.name.toLowerCase()}
                                                    </label>
                                                    {
                                                        row.items.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                                            row.items.map((rs, index2) => {
                                                                let chkSourceId = 'xx';
                                                                if(rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED) {
                                                                    chkSourceId = 'yy' + rs.id;
                                                                }
                                                                else {
                                                                    chkSourceId = 'utmSourceCheck' + rs.id;
                                                                }
                                                                return (
                                                                    <div key={index2} className="form-check ms-2">
                                                                        <input className={"form-check-input" + (rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED ? ' unchecked':'')} name="utmSourceIds[]" type="checkbox" value={rs.id} id={chkSourceId} defaultChecked={rs.isChecked} onClick={e => {
                                                                            if(rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED) {
                                                                                e.target.checked = true;
                                                                            }
                                                                            else {
                                                                                onCheckHead(row.id);
                                                                            }
                                                                        }} disabled={disabled} />
                                                                        <label className="form-check-label" htmlFor={chkSourceId}>
                                                                            {rs.name} {rs.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })
                                                    }
                                                </div>
                                            );
                                        })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} disabled={disabled} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                {
                                    disabled ? '' : <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                        className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                }
                                <NavLink className={"btn btn-sm btn-light" + (disabled ? '':' ms-2')} to='/utmTemplate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 